module.exports = __webpack_public_path__ + "img/supplySolutions4.e12378ca.png";